import React, { PureComponent } from 'react'
import { Form, Input, Modal,Select} from 'antd'
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const {Option} = Select;
const formItemLayout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
}
const title={
    add:'新增企业',
    update:'修改企业'
}
class CompanyModal extends PureComponent {
    state = {

    }


    handleOk = () => {
        const {onOk} = this.props
        const { validateFields, getFieldsValue, resetFields } = this.props.form
        validateFields((errors,values) => {
            if (errors) {
                return
            }
            const data = {
                ...getFieldsValue(),
            }
            resetFields()
          onOk(data)
        })
    }
    hideModal = () =>{
        const {onCancel} = this.props
        const {resetFields } = this.props.form
        onCancel()
        resetFields()
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const {deviceView,action} = this.props
        return (
            <Modal  onOk={this.handleOk}
                    title={title[action]}
                    visible={deviceView}
                    onCancel={this.hideModal}
                    okText="确定"
                    cancelText="取消"
            >
                <Form {...formItemLayout}>
                    <Form.Item label="揽收单位:">
                        {getFieldDecorator('name', {
                            rules: [{required: true, message: '该项必填'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="企业简称:">
                        {getFieldDecorator('shortName', {
                            rules: [{required: true, message: '该项必填'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="联系人:">
                        {getFieldDecorator('linkMan', {
                            rules: [{required: true, message: '该项必填'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="联系电话:">
                        {getFieldDecorator('linkPhone', {
                            rules: [{required: true, message: '该项必填'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="登录账号:">
                        {getFieldDecorator('userName', {
                            rules: [{required: true, message: '该项必填'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="是否启用:">
                        {getFieldDecorator('sts', {
                            initialValue: 'Y',
                            rules: [{required: true, message: '该项必填'}]
                        })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                            <Option value="Y">启用</Option>
                            <Option value="N">停用</Option>
                        </Select>)}
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}
const WrapCompanyModal= Form.create()(CompanyModal)
export default WrapCompanyModal
